<div class="tabcontent p-0">
  <fieldset class="contenttabstyle">
    <div class="row no_row_margin">
      <div class="col-12">
        @if (showTitle) {
          <h2 class="tabcontentTitle">{{ displayTitle }}</h2>
        }
        @if (!isReadOnly) {
          <div class="greytabtop d-flex justify-content-end mb-2">
            <button
              kendoButton
              type="button"
              (click)="_openAddDocumentDialog()"
              class="topRightButtonSecond"
              >
              {{ displayAddButtonText }}
            </button>
            <button
              kendoButton
              type="button"
              (click)="_selectDocumentsHandler($event)"
              class="topRightButton"
              >
              {{ libraryButtonText }}
            </button>
          </div>
        }
        <div class="tabcontent tabWizGridInside">
          <asap-grid-layout
            [returnedSelectedKeys]="_selectedDocumentsKeys"
            [pagingEnabled]="false"
            [enableSiteSelection]="false"
            [data]="documents"
            [isData]="true"
            (doubleClickEvent)="_doDownloadFile($event)"
            class="gridWithcontent"
            >
            <ng-template pageListColumn name="Name" field="name" let-item>
              {{ item.file?.name || item.name || item.filename }}
            </ng-template>
            <ng-template pageListColumn name="Description" field="description" let-item>
              {{ item.file?.description || item.description }}
            </ng-template>
            <ng-template pageListColumn name="Type" field="type" let-item>
              {{ item.file?.type || item.type }}
            </ng-template>
            @if (fileType === 'picture'; as item) {
              <ng-template pageListColumn name="Preview" let-item>
                @if (item.file?.thumbnail || item.file?.stream || item.thumbnail || item.stream) {
                  <img
                    appImagePopup
                    [src]="_storagePath + (item.file?.thumbnail || item.file?.stream || item.thumbnail || item.stream)"
                    [alt]="item.file?.name || item.name || item.filename"
                    [title]="item.file?.name || item.name || item.filename"
                    style="max-width: 45px; max-height: 45px; object-fit: contain; cursor: pointer;"
                    />
                }
              </ng-template>
            }
            @if (showPrimary; as item) {
              <ng-template pageListColumn name="Primary" let-item>
                <input
                  kendoCheckBox
                  type="checkbox"
                  [ngModelOptions]="{ standalone: true }"
                  [ngModel]="item.isPrimary || item.assetFileisPrimary"
                  (ngModelChange)="_setPrimary(item)"
                  [disabled]="isReadOnly"
                  />
                </ng-template>
              }
              @if (!isReadOnly; as item) {
                <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                  <div class="asap-grid-remove" (click)="_removeDocHandler(item)">
                    <div class="asap-grid-remove-icon">
                      <img src="/assets/menu/enterprise/remove-icon.svg" />
                    </div>
                    <div class="asap-grid-remove-text mt-1">Delete</div>
                  </div>
                </ng-template>
              }
            </asap-grid-layout>
          </div>
        </div>
      </div>
    </fieldset>
  </div>

  <!-- File / Document Library Selection Window -->
  @if (_showDocumentsGrid) {
    <kendo-window
      [title]="libraryDialogTitle"
      (close)="_closeDocumentsWindow()"
      class="addFromLibrary"
      >
      <div class="greytabtop">
        <button
          kendoButton
          type="button"
          class="topRightButtonSelect"
          (click)="_returnSelectedDocumentsHandler($event)"
          >
          Select & Return
        </button>
      </div>
      <asap-grid-layout
        [selectable]="true"
        [pagingEnabled]="true"
        [selectByField]="'id'"
        [selectByFieldTitle]="selectByFieldTitle"
        [enableSiteSelection]="false"
        [filteringEnable]="true"
        [sortingEnabled]="true"
        [orderEnable]="true"
        [selectedKeys]="_selectedDocumentsKeys"
        [resolver]="_getAccountFiles"
        (onRowSelectionChanges)="_onDocumentsRowSelectionChanges($event)"
        (onRowObjectSelectionChanges)="_onDocumentObjectRowSelectionChange($event)"
        >
        <ng-template pageListColumn name="Name" field="name" let-item>
          {{ item.name }}
        </ng-template>
        <ng-template pageListColumn name="Description" field="description" let-item>
          {{ item.description }}
        </ng-template>
        <ng-template pageListColumn name="Type" field="type" let-item>
          {{ item.type }}
        </ng-template>
        @if (fileType === 'picture'; as item) {
          <ng-template pageListColumn name="Preview" let-item>
            @if (item.thumbnail || item.stream) {
              <img
                appImagePopup
                [src]="_storagePath + (item.thumbnail || item.stream)"
                [alt]="item.name"
                [title]="item.name"
                style="max-width: 45px; max-height: 45px; object-fit: contain; cursor: pointer;"
                />
            }
          </ng-template>
        }
      </asap-grid-layout>
    </kendo-window>
  }

  <!-- Modal Overlay for Library Window or Upload Dialog -->
  @if (_showDocumentsGrid || _isDialog) {
    <div class="k-overlay"></div>
  }

  <!-- Add File Dialog (Enterprise V2 dynamic form loader) -->
  @if (_isDialog) {
    <asap-dialog-layout
      [componentName]="_dialogComponentName"
      [data]="_dialogModel"
      (closeDialog)="_closeDialog($event)"
    ></asap-dialog-layout>
  }
